import { ApolloClient, InMemoryCache } from "@apollo/client";
import { CHAIN_ID } from "app/constants";
import { GraphByChainId } from "constants/graphUrl";

export const getClient = (chainId = CHAIN_ID) =>
  new ApolloClient({
    uri: GraphByChainId[chainId] || GraphByChainId[Object.keys(GraphByChainId)[0]],
    cache: new InMemoryCache(),
  });
